import React, { useEffect, useState } from 'react';
import classes from '../../../styles/AllDevices.module.css';
import myClasses from '../SmartCharging.module.css';
import { DropdownComponent } from '../../../components/Inputs/Input';
import _ from 'lodash';
import LoadManagement from './LoadManagement';
import { UilSync } from '@iconscout/react-unicons';
import DatePicker from '../../../components/Inputs/DatePicker/DatePicker';
import moment from 'moment';

const SiteOperationsDashboard = ({ sites = [] }) => {
    const [groups, setGroups] = useState([]);
    const [selectedGroup, setSelectedGroup] = useState();
    const [selectedMode, setSelectedMode] = useState({ value: 'siteLoadManagement' });
    const [refresh, setRefresh] = useState(0);
    const [date, setDate] = useState(moment().toDate());

    useEffect(() => {
        const siteLoadManagementSites = sites.filter((site) => site.mode === selectedMode.value);
        setGroups(siteLoadManagementSites);
        if (!_.isEmpty(siteLoadManagementSites)) {
            setSelectedGroup(siteLoadManagementSites[0]);
        } else {
            setGroups([{ label: 'None', value: '' }]);
            setSelectedGroup({ value: '', label: '' });
        }
    }, [sites, selectedMode]);

    return (
        <div className={classes.Ventilation + ' ventilation'}>
            <div className={myClasses.FilterContainer} style={{ alignItems: 'center' }}>
                <div className={myClasses.FilterContainer}>
                    <div className={myClasses.FilterRightSection}>
                        <div className={classes.FieldControl2}>
                            <label>Mode</label>
                            <DropdownComponent
                                name="mode"
                                options={[
                                    { label: 'Site Load Management', value: 'siteLoadManagement' },
                                    { label: 'Load Management & Smart Charge', value: 'loadManagement&smartCharge' },
                                ]}
                                defaultValue={selectedMode}
                                onChange={(e) => setSelectedMode(e)}
                            />
                        </div>
                        <div className={classes.FieldControl2}>
                            <label>Site</label>
                            <DropdownComponent name="groupId" options={groups} defaultValue={selectedGroup} onChange={(e) => setSelectedGroup(e)} />
                        </div>
                        <div className={classes.FieldControl2}>
                            <label>Date</label>
                            <DatePicker date={date} setDate={setDate} />
                        </div>
                    </div>
                </div>
                <div className={myClasses.Header}>
                    <div className={classes.FieldControl2} onClick={() => setRefresh(Date.now())} style={{ display: 'flex', alignItems: 'center', justifyContent: 'end' }}>
                        <UilSync style={{ color: 'var(--color-primary)' }} />
                    </div>
                </div>
            </div>
            <LoadManagement selectedGroup={selectedGroup} refresh={refresh} date={date} selectedMode={selectedMode}/>
        </div>
    );
};

export default SiteOperationsDashboard;
